/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ExternalShipmentShowHomeContentQueryVariables = {
    slug: string;
};
export type ExternalShipmentShowHomeContentQueryResponse = {
    readonly externalShipmentShow: {
        readonly slug: string;
        readonly folders: {
            readonly " $fragmentRefs": FragmentRefs<"ExternalFoldersCard_folders" | "ExternalUploadDocumentsWizard_folders">;
        };
        readonly draftContacts: {
            readonly " $fragmentRefs": FragmentRefs<"LinkedContactsCard_draftContacts">;
        };
        readonly linkedContacts: {
            readonly " $fragmentRefs": FragmentRefs<"LinkedContactsCard_linkedContacts">;
        };
        readonly draftLinkedContactRoles: {
            readonly " $fragmentRefs": FragmentRefs<"LinkedContactsCard_draftLinkedContactRoles">;
        };
        readonly liveRequests: {
            readonly " $fragmentRefs": FragmentRefs<"LiveRequest_liveRequests">;
        };
        readonly emails: {
            readonly " $fragmentRefs": FragmentRefs<"EmailsCard_emails">;
        };
        readonly " $fragmentRefs": FragmentRefs<"ExternalShipmentInfoCard_shipment" | "ExternalShipmentCompanyCard_shipment" | "ExternalUploadDocumentsWizard_shipment">;
    };
};
export type ExternalShipmentShowHomeContentQuery = {
    readonly response: ExternalShipmentShowHomeContentQueryResponse;
    readonly variables: ExternalShipmentShowHomeContentQueryVariables;
};



/*
query ExternalShipmentShowHomeContentQuery(
  $slug: String!
) {
  externalShipmentShow(slug: $slug) {
    slug
    ...ExternalShipmentInfoCard_shipment
    ...ExternalShipmentCompanyCard_shipment
    ...ExternalUploadDocumentsWizard_shipment
    folders {
      ...ExternalFoldersCard_folders
      ...ExternalUploadDocumentsWizard_folders
    }
    draftContacts {
      ...LinkedContactsCard_draftContacts
    }
    linkedContacts {
      ...LinkedContactsCard_linkedContacts
    }
    draftLinkedContactRoles {
      ...LinkedContactsCard_draftLinkedContactRoles
    }
    liveRequests {
      ...LiveRequest_liveRequests
    }
    emails {
      ...EmailsCard_emails
    }
    id
  }
}

fragment Attachment_attachment on Attachment {
  url
  name
  contentType
  previewUrl
}

fragment EmailItem_email on Email {
  slug
  subject
  from
  to
  body
  sentAt
  attachments {
    name
    ...SmallAttachment_attachment
    ...Attachment_attachment
  }
}

fragment EmailsCard_emails on EmailConnection {
  nodes {
    slug
    ...EmailItem_email
    id
  }
}

fragment EntityAttachmentListItem_attachment on EntityAttachment {
  url
  downloadUrl
  name
  contentType
  previewUrl
  documentType
  roleVisibilities {
    role
    roleShortTitle
    roleTitle
    visible
  }
  uploadedAtDisplay
  uploadedAt
}

fragment EntityAttachmentListPreviewer_attachment on EntityAttachment {
  url
  downloadUrl
  name
  contentType
  previewUrl
  documentType
  entityType
  entitySlug
  attachmentSlug
  thumbnailImage
  ...EntityAttachmentRoleVisibility_attachment
}

fragment EntityAttachmentRoleVisibility_attachment on EntityAttachment {
  name
  attachmentSlug
  entityType
  entitySlug
  roleVisibilities {
    role
    roleShortTitle
    roleTitle
    visible
  }
}

fragment EntityAttachment_attachment on EntityAttachment {
  url
  downloadUrl
  name
  contentType
  previewUrl
  documentType
  draftTicketStatus
  lexOfficeInvoiceStatus
  signedStatus
  rejectReason
}

fragment ExternalFolder_folder on Folder {
  slug
  entitySlug
  entityType
  name
  parentType
  attachments {
    attachmentSlug
    name
    isImage
    ...EntityAttachmentListPreviewer_attachment
    ...EntityAttachment_attachment
    ...EntityAttachmentListItem_attachment
    id
  }
  ...FileCreationDialog_folder
}

fragment ExternalFoldersCard_folders on FolderConnection {
  nodes {
    slug
    activeTicket
    parentType
    ...ExternalFolder_folder
    id
  }
}

fragment ExternalShipmentCompanyCard_shipment on ExternalShipment {
  slug
  company {
    eori
    eoriValid
    eoriValidatedAt
    vat
    vatValid
    vatValidatedAt
    id
  }
  eoriDocGeneratedAt
  vatDocGeneratedAt
}

fragment ExternalShipmentInfoCard_shipment on ExternalShipment {
  slug
  customerInfoText
  stage
  requiredDocuments
  infoExternalField {
    label
    name
    value
  }
}

fragment ExternalUploadDocumentsWizard_folders on FolderConnection {
  nodes {
    slug
    activeTicket
    parentType
    attachments {
      id
      documentType
    }
    id
  }
}

fragment ExternalUploadDocumentsWizard_shipment on ExternalShipment {
  slug
  requiredDocuments
}

fragment FileCreationDialog_folder on Folder {
  slug
  name
}

fragment LinkedContactsCard_draftContacts on DraftContactConnection {
  nodes {
    slug
    name
    displayRoles
    image {
      url
      alt
    }
    id
  }
}

fragment LinkedContactsCard_draftLinkedContactRoles on DraftContactLinkRoleConnection {
  nodes {
    role
    ticketStatus
    contactLink {
      displayRole
      displayName
      contactItem {
        slug
        title
        image {
          url
          alt
        }
        id
      }
    }
  }
}

fragment LinkedContactsCard_linkedContacts on ContactLinkConnection {
  nodes {
    role
    displayRole
    displayName
    contactItem {
      slug
      title
      image {
        url
        alt
      }
      id
    }
  }
}

fragment LiveRequest_liveRequests on TicketConnection {
  nodes {
    slug
    title
    status
    direction
    ticketType
    absoluteSlugs
    raisedAt
    displayStatus
    raisedBy {
      name
      id
    }
    raisedFor {
      name
      id
    }
    id
  }
}

fragment SmallAttachment_attachment on Attachment {
  url
  name
  contentType
  previewUrl
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entitySlug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previewUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayRole",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "ListItem",
  "kind": "LinkedField",
  "name": "contactItem",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v14/*: any*/),
    (v11/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v16 = [
  (v3/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalShipmentShowHomeContentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExternalShipment",
        "kind": "LinkedField",
        "name": "externalShipmentShow",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FolderConnection",
            "kind": "LinkedField",
            "name": "folders",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ExternalFoldersCard_folders"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ExternalUploadDocumentsWizard_folders"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftContactConnection",
            "kind": "LinkedField",
            "name": "draftContacts",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LinkedContactsCard_draftContacts"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactLinkConnection",
            "kind": "LinkedField",
            "name": "linkedContacts",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LinkedContactsCard_linkedContacts"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftContactLinkRoleConnection",
            "kind": "LinkedField",
            "name": "draftLinkedContactRoles",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LinkedContactsCard_draftLinkedContactRoles"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketConnection",
            "kind": "LinkedField",
            "name": "liveRequests",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LiveRequest_liveRequests"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailConnection",
            "kind": "LinkedField",
            "name": "emails",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EmailsCard_emails"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ExternalShipmentInfoCard_shipment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ExternalShipmentCompanyCard_shipment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ExternalUploadDocumentsWizard_shipment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalShipmentShowHomeContentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExternalShipment",
        "kind": "LinkedField",
        "name": "externalShipmentShow",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerInfoText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requiredDocuments",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ExternalInfoField",
            "kind": "LinkedField",
            "name": "infoExternalField",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eori",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eoriValid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eoriValidatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vatValid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vatValidatedAt",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eoriDocGeneratedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vatDocGeneratedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FolderConnection",
            "kind": "LinkedField",
            "name": "folders",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Folder",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activeTicket",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parentType",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EntityAttachment",
                    "kind": "LinkedField",
                    "name": "attachments",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attachmentSlug",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isImage",
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "downloadUrl",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "documentType",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "thumbnailImage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoleVisibility",
                        "kind": "LinkedField",
                        "name": "roleVisibilities",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "roleShortTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "roleTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "visible",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "draftTicketStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lexOfficeInvoiceStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "signedStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rejectReason",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "uploadedAtDisplay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "uploadedAt",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftContactConnection",
            "kind": "LinkedField",
            "name": "draftContacts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DraftContact",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayRoles",
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactLinkConnection",
            "kind": "LinkedField",
            "name": "linkedContacts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContactLink",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftContactLinkRoleConnection",
            "kind": "LinkedField",
            "name": "draftLinkedContactRoles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DraftContactLinkRole",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ticketStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactLink",
                    "kind": "LinkedField",
                    "name": "contactLink",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketConnection",
            "kind": "LinkedField",
            "name": "liveRequests",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Ticket",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "direction",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ticketType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "absoluteSlugs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "raisedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Contact",
                    "kind": "LinkedField",
                    "name": "raisedBy",
                    "plural": false,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Contact",
                    "kind": "LinkedField",
                    "name": "raisedFor",
                    "plural": false,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailConnection",
            "kind": "LinkedField",
            "name": "emails",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Email",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subject",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "from",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "to",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "body",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sentAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attachment",
                    "kind": "LinkedField",
                    "name": "attachments",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cc1625fbedc6cf4ca9bfa9ffb97bc858",
    "id": null,
    "metadata": {},
    "name": "ExternalShipmentShowHomeContentQuery",
    "operationKind": "query",
    "text": "query ExternalShipmentShowHomeContentQuery(\n  $slug: String!\n) {\n  externalShipmentShow(slug: $slug) {\n    slug\n    ...ExternalShipmentInfoCard_shipment\n    ...ExternalShipmentCompanyCard_shipment\n    ...ExternalUploadDocumentsWizard_shipment\n    folders {\n      ...ExternalFoldersCard_folders\n      ...ExternalUploadDocumentsWizard_folders\n    }\n    draftContacts {\n      ...LinkedContactsCard_draftContacts\n    }\n    linkedContacts {\n      ...LinkedContactsCard_linkedContacts\n    }\n    draftLinkedContactRoles {\n      ...LinkedContactsCard_draftLinkedContactRoles\n    }\n    liveRequests {\n      ...LiveRequest_liveRequests\n    }\n    emails {\n      ...EmailsCard_emails\n    }\n    id\n  }\n}\n\nfragment Attachment_attachment on Attachment {\n  url\n  name\n  contentType\n  previewUrl\n}\n\nfragment EmailItem_email on Email {\n  slug\n  subject\n  from\n  to\n  body\n  sentAt\n  attachments {\n    name\n    ...SmallAttachment_attachment\n    ...Attachment_attachment\n  }\n}\n\nfragment EmailsCard_emails on EmailConnection {\n  nodes {\n    slug\n    ...EmailItem_email\n    id\n  }\n}\n\nfragment EntityAttachmentListItem_attachment on EntityAttachment {\n  url\n  downloadUrl\n  name\n  contentType\n  previewUrl\n  documentType\n  roleVisibilities {\n    role\n    roleShortTitle\n    roleTitle\n    visible\n  }\n  uploadedAtDisplay\n  uploadedAt\n}\n\nfragment EntityAttachmentListPreviewer_attachment on EntityAttachment {\n  url\n  downloadUrl\n  name\n  contentType\n  previewUrl\n  documentType\n  entityType\n  entitySlug\n  attachmentSlug\n  thumbnailImage\n  ...EntityAttachmentRoleVisibility_attachment\n}\n\nfragment EntityAttachmentRoleVisibility_attachment on EntityAttachment {\n  name\n  attachmentSlug\n  entityType\n  entitySlug\n  roleVisibilities {\n    role\n    roleShortTitle\n    roleTitle\n    visible\n  }\n}\n\nfragment EntityAttachment_attachment on EntityAttachment {\n  url\n  downloadUrl\n  name\n  contentType\n  previewUrl\n  documentType\n  draftTicketStatus\n  lexOfficeInvoiceStatus\n  signedStatus\n  rejectReason\n}\n\nfragment ExternalFolder_folder on Folder {\n  slug\n  entitySlug\n  entityType\n  name\n  parentType\n  attachments {\n    attachmentSlug\n    name\n    isImage\n    ...EntityAttachmentListPreviewer_attachment\n    ...EntityAttachment_attachment\n    ...EntityAttachmentListItem_attachment\n    id\n  }\n  ...FileCreationDialog_folder\n}\n\nfragment ExternalFoldersCard_folders on FolderConnection {\n  nodes {\n    slug\n    activeTicket\n    parentType\n    ...ExternalFolder_folder\n    id\n  }\n}\n\nfragment ExternalShipmentCompanyCard_shipment on ExternalShipment {\n  slug\n  company {\n    eori\n    eoriValid\n    eoriValidatedAt\n    vat\n    vatValid\n    vatValidatedAt\n    id\n  }\n  eoriDocGeneratedAt\n  vatDocGeneratedAt\n}\n\nfragment ExternalShipmentInfoCard_shipment on ExternalShipment {\n  slug\n  customerInfoText\n  stage\n  requiredDocuments\n  infoExternalField {\n    label\n    name\n    value\n  }\n}\n\nfragment ExternalUploadDocumentsWizard_folders on FolderConnection {\n  nodes {\n    slug\n    activeTicket\n    parentType\n    attachments {\n      id\n      documentType\n    }\n    id\n  }\n}\n\nfragment ExternalUploadDocumentsWizard_shipment on ExternalShipment {\n  slug\n  requiredDocuments\n}\n\nfragment FileCreationDialog_folder on Folder {\n  slug\n  name\n}\n\nfragment LinkedContactsCard_draftContacts on DraftContactConnection {\n  nodes {\n    slug\n    name\n    displayRoles\n    image {\n      url\n      alt\n    }\n    id\n  }\n}\n\nfragment LinkedContactsCard_draftLinkedContactRoles on DraftContactLinkRoleConnection {\n  nodes {\n    role\n    ticketStatus\n    contactLink {\n      displayRole\n      displayName\n      contactItem {\n        slug\n        title\n        image {\n          url\n          alt\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment LinkedContactsCard_linkedContacts on ContactLinkConnection {\n  nodes {\n    role\n    displayRole\n    displayName\n    contactItem {\n      slug\n      title\n      image {\n        url\n        alt\n      }\n      id\n    }\n  }\n}\n\nfragment LiveRequest_liveRequests on TicketConnection {\n  nodes {\n    slug\n    title\n    status\n    direction\n    ticketType\n    absoluteSlugs\n    raisedAt\n    displayStatus\n    raisedBy {\n      name\n      id\n    }\n    raisedFor {\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment SmallAttachment_attachment on Attachment {\n  url\n  name\n  contentType\n  previewUrl\n}\n"
  }
};
})();
(node as any).hash = '4daf5aaccf04317758aa8ab968b93319';
export default node;
